export default "https://cdn-gra.amplement.io/statics/images/file/file-sketch.svg";